import React from 'react';
import Typography from '@material-ui/core/Typography';
import useStyles from '../assets/jss/title-styles';

export default function Title(props) {
  const classes = useStyles();
  return (
    <Typography component='h2' variant='h6' color='primary' gutterBottom className={classes.root}>
      {props.children}
    </Typography>
  );
}
